import { render, staticRenderFns } from "./Link3Login.vue?vue&type=template&id=9c9504b8&scoped=true&"
import script from "./Link3Login.vue?vue&type=script&lang=js&"
export * from "./Link3Login.vue?vue&type=script&lang=js&"
import style0 from "./Link3Login.vue?vue&type=style&index=0&id=9c9504b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9504b8",
  null
  
)

export default component.exports